import Fetch from 'utils/fetch';

export const completeTask = (taskId, userId) => {
    return Fetch.post(`/visaoTarefa/completeTask`, { taskId: taskId, userId: userId });
}